import React, { useState, useEffect, useContext, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../BaseUrl";
import { toast } from "react-toastify";
import { UserContext } from "./User";
//functions
import { getCookie, getApiUrl, getOffline } from "../functions/Functions";
import { SettingsContext } from "./Settings";

//3rd party packages

// creating context api
const RestaurantContext = React.createContext();

const RestaurantProvider = ({ children }) => {
  const { authUserInfo } = useContext(UserContext);
  const { generalSettings } = useContext(SettingsContext);

  // State hooks  here
  //loading
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [dataPaginating, setDataPaginating] = useState(false);

  //website
  const [branchListWeb, setBranchListWeb] = useState(null);

  //delivery user
  const [pendingOrdersDelivery, setPendingOrdersDelivery] = useState(null);
  const [pendingOrdersDeliveryForSearch, setPendingOrdersDeliveryForSearch] =
    useState(null);
  const [deliveredOrdersDelivery, setDeliveredOrdersDelivery] = useState(null);
  const [
    deliveredOrdersDeliveryForSearch,
    setDeliveredOrdersDeliveryForSearch,
  ] = useState(null);

  //ingredientGroup
  const [ingredientGroupList, setIngredientGroupList] = useState(null);
  const [ingredientGroupForSearch, setIngredientGroupForSearch] =
    useState(null);

  //ingredientItem
  const [ingredientItemList, setIngredientItemList] = useState(null);
  const [ingredientItemForSearch, setIngredientItemForSearch] = useState(null);
  const [ingredientItemNonPurchase, setIngredientItemNonPurchase] = useState(null);
  const [ingredientItemListForSearch, setIngredientItemListForSearch] =
    useState(null);
  //brand
  const [brandList, setBrandList] = useState(null);
  const [brandForSearch, setBrandForSearch] = useState(null);
  const [brandStatus, setbrandStatus] = useState(null);
  const [ingredientLimitList, setIngredientLimitList] = useState(null);
  const [ingredientLimitForSearch, setIngredientLimitForSearch] =
    useState(null);
  const [ingredientLimitCheck, setIngredientLimitCheck] = useState(null);
  const [ingredientItemStock, setIngredientItemStock] = useState(null);
  const [ingredientPurchaseHistory, setIngredientPurchaseHistory] =
    useState(null);
  const [
    ingredientPurchaseHistoryForSearch,
    setIngredientPurchaseHistoryForSearch,
  ] = useState(null);
  const [saleInvoice, setSaleInvoice] = useState(null);
  const [saleInvoiceForSearch, setSaleInvoiceForSearch] = useState(null);
  const [purchaseReturnHistory, setPurchaseReturnHistory] = useState(null);
  const [purchaseHistoryReturnForSearch, setPurchaseHistoryReturnForSearch] =
    useState(null);
  const [bellRing, setBellRing] = useState(false);
  const audioInstance = useRef(null);
  const abortControllersRef = useRef(new Map());

  // Helper to manage AbortControllers per API to avoid cross-cancelling different APIs
  const getAbortController = (key) => {
    if (abortControllersRef.current.has(key)) {
      abortControllersRef.current.get(key).abort();
    }
    const controller = new AbortController();
    abortControllersRef.current.set(key, controller);
    return controller;
  };

  //production
  const [productionItemList, setProductionItemList] = useState(null);
  const [productionItemForSearch, setProductionItemForSearch] = useState(null);

  //microsoft integrauion
  const [MdIntegrationList, setMdIntegrationList] = useState(null);
  const [MdIntegrationForSearch, setMdIntegrationForSearch] = useState(null);
  const [expense, setExpense] = useState(null);
  const [expenseForSearch, setExpenseForSearch] = useState(null);

  //status state
  const [orderStatus, setOrderStatus] = useState(null);

  const [expensePayment, setPaymentExpense] = useState(null);
  const [paymentExpenseForSearch, setPaymentExpenseForSearch] = useState(null);

  //branch
  const [branchList, setBranchList] = useState(null);
  const [branchForSearch, setBranchforSearch] = useState(null);

  //branch list
  //branch
  const [getBranchList, setGetBranchList] = useState(null);
  const [getBranchForSearch, setGetBranchforSearch] = useState(null);
  const [branchForListSearch, setBranchListforSearch] = useState(null);

  //OrderType
  const [orderTypeList, setOrderTypeList] = useState(null);
  const [orderTypeForSearch, setOrderTypeForSearch] = useState(null);

  //area and zone
  const [zoneList, setZoneList] = useState(null);
  const [zoneForSearch, setZoneForSearch] = useState(null);

  //location
  const [locationList, setLocationList] = useState(null);
  const [locationForSearch, setLocationForSearch] = useState(null);

  //reason
  const [reasonList, setReasonList] = useState(null);
  const [reasonForSearch, setReasonForSearch] = useState(null);


  const [areaList, setAreaList] = useState(null);
  const [areaForSearch, setAreaForSearch] = useState(null);

  //table
  const [tableList, setTableList] = useState(null);
  const [tableForSearch, setTableforSearch] = useState(null);

  //floor
  const [floorList, setFloorList] = useState(null);
  const [floorForSearch, setFloorforSearch] = useState(null);

  //depart
  const [deptTagList, setDeptTagList] = useState(null);
  const [deptTagForSearch, setDeptTagForSearch] = useState(null);

  //kot
  const [KOTList, setKOTList] = useState(null);
  const [KOTForSearch, setKOTForSearch] = useState(null);

  //Scheme
  const [schemeList, setSchemeList] = useState(null);
  const [schemeForSearch, setSchemeForSearch] = useState(null);
  const [schemeForSearchObj, setSchemeForSearchObj] = useState(null);

  //Cards
  const [cardList, setCardList] = useState(null);
  const [cardForSearch, setCardForSearch] = useState(null);

  //voucher master
  const [voucherMaster, setVoucherMaster] = useState(null);

  //Voucher
  const [voucherList, setVoucherList] = useState(null);
  const [voucherForSearch, setVoucherForSearch] = useState(null);

  //Payment Type
  const [paymentTypeList, setPaymentTypeList] = useState(null);
  const [paymentTypeForSearch, setPaymentTypeforSearch] = useState(null);

  //Payment Type
  const [paymentTypeTaxForSearch, setPaymentTypeTaxforSearch] = useState(null);

  //Bank Name
  const [bankNameForSearch, setBankNameForSearch] = useState(null);

  //work period
  const [workPeriodList, setWorkPeriodList] = useState(null);
  //const [dayOpen, setDayOpen] = useState(null);
  const [workPeriodForSearch, setWorkPeriodListForSearch] = useState(null);
  const [workPeriodListForBranch, setWorkPeriodListForBranch] = useState(null);

  //submitted orders
  const [submittedOrders, setSubmittedOrders] = useState(null);
  const [submittedOrdersForSearch, setSubmittedOrdersForSearch] =
    useState(null);
  const [runningOrders, setRunningOrders] = useState(null);

  //settled orders
  const [settledOrders, setSettledOrders] = useState(null);
  const [settledOrdersForSearch, setSettledOrdersForSearch] = useState(null);

  //kitchen new orders
  const [kithcenNewOrders, setKithcenNewOrders] = useState(null);
  const [kithcenNewOrdersOnline, setKithcenNewOrdersOnline] = useState(null);

  //all orders
  const [allOrders, setAllOrders] = useState(null);
  const [allOrdersForSearch, setAllOrdersForSearch] = useState(null);

  //all orders
  const [allOnlineOrders, setAllOnlineOrders] = useState(null);
  const [allOnlineOrdersForSearch, setAllOnlineOrdersForSearch] =
    useState(null);
  const [ingredientList, setIngredientList] = useState(null);
  const [ingredientUnitForSearch, setIngredientUnitForSearch] = useState(null);

  // recipes
  const [recipeList, setRecipeList] = useState(null);
  const [recipeForSearch, setRecipeForSearch] = useState(null);
  //purchase order
  const [purchaseOrderList, setPurchaseOrderList] = useState(null);
  const [purchaseOrderListForSearch, setPurchaseOrderListForSearch] =
    useState(null);
  //closing stock
  const [closingStockList, setClosingStockList] = useState(null);
  const [closingStockListForSearch, setClosingStockListForSearch] =
    useState(null);
  //purchase Request
  const [purchaseRequestList, setPurchaseRequestList] = useState(null);
  const [purchaseRequestListForSearch, setPurchaseRequestListForSearch] =
    useState(null);
  //sale order
  const [fgSaleInvoiceList, setFgSaleInvoiceList] = useState(null);
  const [fgSaleInvoiceForSearch, setFgSaleInvoiceForSearch] = useState(null);

  //sale return order
  const [fgSaleReturnList, setFgSaleReturnList] = useState(null);
  const [fgSaleReturnForSearch, setFgSaleReturnForSearch] = useState(null);

  //fg sale order
  const [fgSaleOrderList, setFgSaleOrderList] = useState(null);
  const [fgSaleOrderForSearch, setFgSaleOrderForSearch] = useState(null);

  //sale return
  const [saleReturnList, setSaleReturnList] = useState(null);
  const [saleReturnForSearch, setSaleReturnForSearch] = useState(null);

  // good notes
  const [goodReceiveList, setGoodReceiveList] = useState(null);
  const [goodReceiveListForSearch, setGoodReceiveListForSearch] =
    useState(null);

  // kds setting
  const [kdsList, setKdsList] = useState(null);
  const [kdsListForSearch, setKdsListForSearch] = useState(null);

  //online order counter
  const [orderCounter, setOrderCounter] = useState({
    online: 0,
    foodPanda: 0,
    ready: 0,
  });

  // localStorage helper
  const setDataToLocal = (url, res) => {
    try {
      localStorage.setItem(url, JSON.stringify(res));
    } catch (err) {
      setLoading(false);
      console.log("err", err);
    }
  };

  // localStorage helper
  const getDataFromLocal = (url) => {
    return JSON.parse(localStorage.getItem(url));
  };

  //check if offline helper
  const offline = (url) => {
    return localStorage.getItem(url) != null;
  };

  //useEffect- to get data on render
  useEffect(() => {
    async function fetchData() {
      //call- unauthenticated
      getBranchWeb();
      //call if authenticated
      if (
        getCookie() !== undefined ||
        (await getOffline(BASE_URL + "/auth/user"))
      ) {
        getBranch();
        getZones();
        getAreas();
        getOrderType();
        getFloor();
        GetBranchList();
        getDeptTag();
        getScheme();
        getCard();
        // getVoucher();
        getPaymentType();
        // getPaymentTypeTax();
        // getBankNameList();
        getWorkPeriod();
        getWorkPeriodForBranch();
        // getDeliveryPendingOrders();
        // getDeliveryDeliveredOrders();
        // getIngredientUnit();
        // getRecipes();
        getIngredientItem();
        // getProductionItem();
        getExpense();
        getExpenseList();
        getKdsList();
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (!authUserInfo?.details) return;
    async function fetchData() {
      //call if authenticated
      if (
        getCookie() !== undefined ||
        (await getOffline(BASE_URL + "/auth/user"))
      ) {
        getTable();
      }
    }
    fetchData();
  }, [authUserInfo?.details]);

  const setDeliveryPendingOrder = (res) => {
    setPendingOrdersDelivery(res.data[0]);
    setPendingOrdersDeliveryForSearch(res.data[1]);
    setLoading(false);
  };

  const setPaginatedIngredientUnits = (res) => {
    setIngredientList(res.data[0]);
    setIngredientUnitForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated ing units  // Priority ->
  const setPaginatedIngredientUnit = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/unit?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedIngredientUnits(res);
      setDataToLocal(url, res);
    } catch (error) {
      if (offline(url)) {
        let parseRes = getDataFromLocal(url);
        setPaginatedIngredientUnits(parseRes);
      }
    }
  };

  //get status
  const getStatus = () => {
    const url = BASE_URL + "/website/get-all-order-status";
    return axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${getCookie()}`,
        },
      })
      .then((res) => {
        setOrderStatus(res.data);
      })
      .catch((err) => {
        toast.error("Can't get status something went wrong!");
      });
  };

  // get ingredients form api
  const getIngredientUnit = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/unit";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      // setDataToLocal(url, res);
      setIngredientList(res.data[0]);
      setIngredientUnitForSearch(res.data[1]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const setPaginatedRecipeLists = (res) => {
    setRecipeList(res.data[0]);
    setRecipeForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated ing units  // Priority ->
  const setPaginatedRecipeList = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/recipe?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedRecipeLists(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedIngredientUnits(parseRes);
      // }
    }
  };

  // get recipes form api
  const getRecipes = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/recipe";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      // setDataToLocal(url, res);
      setRecipeList(res.data[0]);
      setRecipeForSearch(res.data[1]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("recipe error", error);
    }
  };

  //get deliveryman pending orders
  const getDeliveryPendingOrders = async () => {
    setLoading(true);
    const ordersUrl = BASE_URL + "/settings/get-assigned-orders";
    try {
      const res = await axios.get(ordersUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setDeliveryPendingOrder(res);
      // setDataToLocal(ordersUrl, res);
    } catch (error) {
      setLoading(false);
      // if (offline(ordersUrl)) {
      //   let parseRes = getDataFromLocal(ordersUrl);
      //   setDeliveryPendingOrder(parseRes);
      // }
    }
  };

  //Helper
  const setPaginatedDeliveryPendingOrder = (res) => {
    setPendingOrdersDelivery(res.data[0]);
    setPendingOrdersDeliveryForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated deliveryman pending orders
  const setPaginatedDeliveryPendingOrders = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-assigned-orders?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedDeliveryPendingOrder(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedDeliveryPendingOrder(parseRes);
      // }
    }
  };

  // Helper
  const setDeliveryDeliveredOrder = (res) => {
    setDeliveredOrdersDelivery(res.data[0]);
    setDeliveredOrdersDeliveryForSearch(res.data[1]);
    setLoading(false);
  };

  //get deliveryman delivered orders
  const getDeliveryDeliveredOrders = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-delivered-orders";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setDeliveryDeliveredOrder(res);
      // setDataToLocal(url, res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setDeliveryDeliveredOrder(parseRes);
      // }
      setLoading(false);
    }
  };

  //Helper
  const setPaginatedDeliveryDeliveredOrder = (res) => {
    setDeliveredOrdersDelivery(res.data[0]);
    setDeliveredOrdersDeliveryForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated deliveryman delivered orders
  const setPaginatedDeliveryDeliveredOrders = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-delivered-orders?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedDeliveryDeliveredOrder(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedDeliveryDeliveredOrder(parseRes);
      // }
    }
  };

  const setIngredientGroups = (res) => {
    setIngredientGroupList(res.data[0]);
    setIngredientGroupForSearch(res.data[1]);
    setLoading(false);
  };

  //get ingredient group
  const getIngredientGroup = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-ingredient_group";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setIngredientGroups(res);
      setDataToLocal(url, res);
    } catch (error) {
      if (offline(url)) {
        let parseRes = getDataFromLocal(url);
        setIngredientGroups(parseRes);
      }
      setLoading(false);
    }
  };

  const setPaginatedIngredientGroups = (res) => {
    setIngredientGroupList(res.data[0]);
    setIngredientGroupForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated ingredient group
  const setPaginatedIngredientGroup = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-ingredient_group?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedIngredientGroups(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedIngredientGroups(parseRes);
      // }
    }
  };

  const setProductionItems = (res) => {
    setProductionItemList(res.data[0]);
    setProductionItemForSearch(res.data[1]);
    setLoading(false);
  };

  //get ingredient item
  const getProductionItem = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-production";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setProductionItems(res);
      //  setDataToLocal(url, res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setProductionItems(parseRes);
      // }
      setLoading(false);
    }
  };

  const setPaginatedProductionItems = (res) => {
    setProductionItemList(res.data[0]);
    setProductionItemForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated ingredient item
  const setPaginatedProductionItem = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-production?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedProductionItems(res);
      // setDataToLocal(url, res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedProductionItems(parseRes);
      // }
      setDataPaginating(false);
    }
  };

  const setIngredientItems = (res) => {
    setIngredientItemList(res.data[0]);
    setIngredientItemListForSearch(res.data[1]);
    setIngredientItemStock(res.data[2]);
    setIngredientItemForSearch(res.data[3]);
    setIngredientItemNonPurchase(res.data[4])
    setLoading(false);
  };

  //get ingredient item
  const getIngredientItem = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-ingredient_item";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setIngredientItems(res);
      setDataToLocal(url, res);
    } catch (error) {
      if (offline(url)) {
        let parseRes = getDataFromLocal(url);
        setIngredientItems(parseRes);
      }
    }
  };

  const setPaginatedIngredientItems = (res) => {
    setIngredientItemList(res.data[0]);
    setIngredientItemListForSearch(res.data[1]);
    setIngredientItemStock(res.data[2]);
    setIngredientItemForSearch(res.data[3]);
    setIngredientItemNonPurchase(res.data[4])
    setDataPaginating(false);
  };

  // get paginated ingredient item
  const setPaginatedIngredientItem = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-ingredient_item?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedIngredientItems(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedIngredientItems(parseRes);
      // }
    }
  };

  const setMdIntegrationGroups = (res) => {
    setMdIntegrationList(res.data[0]);
    setMdIntegrationForSearch(res.data[1]);
    setLoading(false);
  };

  //get ingredient group
  const getMdIntegrationGroup = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/md-accounts-list";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setMdIntegrationGroups(res);
    } catch (error) {
      setLoading(false);
    }
  };

  const setPaginatedMdIntegraionGroups = (res) => {
    setMdIntegrationList(res.data[0]);
    setMdIntegrationForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated ingredient group
  const setPaginatedMdIntegrationGroup = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/md-accounts-list?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedMdIntegraionGroups(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setBrands = (res) => {
    setBrandList(res.data[0]);
    setBrandForSearch(res.data[2]);
    setbrandStatus(res.data[1]);
    setDataPaginating(false);
  };

  //get ingredient limit
  const setBrandPagination = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/food-brand?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setBrands(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setIngredientLimit = (res) => {
    setIngredientLimitList(res.data[0]);
    setIngredientLimitForSearch(res.data[1]);
    setIngredientLimitCheck(res.data[2]);
    setLoading(false);
  };

  //get ingredient limit
  const getIngredientLimit = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/ingredient-limit";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setIngredientLimit(res);
    } catch (error) {
      setLoading(false);
    }
  };

  const setPaginatedIngredientLimits = (res) => {
    setIngredientLimitList(res.data[0]);
    setIngredientLimitForSearch(res.data[1]);
    setIngredientLimitCheck(res.data[2]);
    setDataPaginating(false);
  };

  // get paginated ingredient item limit
  const setPaginatedIngredientLimit = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/ingredient-limit?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedIngredientLimits(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setBranchWeb = (res) => {
    setBranchListWeb(res.data);
    setLoading(false);
  };

  // paginated branch list
  const setPaginatedBranchesList = (res) => {
    setGetBranchList(res.data[0]);
    setGetBranchforSearch(res.data[1]);
    setBranchListforSearch(res.data[2]);
    setDataPaginating(false);
  };

  const GetBranchList = async () => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-branch-list";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedBranchesList(res);
      setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setPaginatedBranchesList(parseRes);
      }
    }
  };

  // paginated branch list
  const setPaginatedBranchList = (res) => {
    setGetBranchList(res.data[0]);
    setGetBranchforSearch(res.data[1]);
    setDataPaginating(false);
  };
  const getPaginatedBranchList = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-branch-list?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedBranchList(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedBranchList(parseRes);
      // }
    }
  };

  //get branchWeb
  const getBranchWeb = async () => {
    setLoading(true);
    const url = BASE_URL + "/website/get-branch-web";
    try {
      const res = await axios.get(url);
      setBranchWeb(res);
      setDataToLocal(url, res);
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = getDataFromLocal(url);
        setBranchWeb(parseRes);
      }
    }
  };

  const setBranches = (res) => {
    setBranchList(res.data[0]);
    setBranchforSearch(res.data[1]);
    setBranchListforSearch(res.data[2]);
    setLoading(false);
  };

  //get branch   // Priority ->
  const getBranch = async () => {
    setLoading(true);
    const branchUrl = BASE_URL + "/settings/get-manager-branches";
    try {
      const res = await axios.get(branchUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setBranches(res);
      setDataToLocal(branchUrl, res);
    } catch (error) {
      setLoading(false);
      if (offline(branchUrl)) {
        let parseRes = JSON.parse(localStorage.getItem(branchUrl));
        setBranches(parseRes);
      }
    }
  };

  const setPaginatedBranches = (res) => {
    setBranchList(res.data[0]);
    setBranchforSearch(res.data[1]);
    setBranchListforSearch(res.data[2]);
    setDataPaginating(false);
  };

  // get paginated branch
  const setPaginatedBranch = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-manager-branches?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedBranches(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedBranches(parseRes);
      // }
    }
  };

  // get areas
  const getAreas = async () => {
    const areasUrl = BASE_URL + "/settings/get-area-list";

    try {
      const response = await axios.get(areasUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (response.data.code == 1) {
        setAreaList(response.data.details?.mappedAreas);
        setAreaForSearch(response.data.details?.unMappedAreas);

        if (response.data?.details?.areaList) {
          delete response.data.detail.areaList;
        }

        setDataToLocal(areasUrl, response.data);
      }
    } catch (error) {
      if (!navigator.onLine && localStorage.getItem(areasUrl) != null) {
        const parseRes = JSON.parse(localStorage.getItem(areasUrl));

        setAreaList(parseRes.details?.mappedAreas || []);
        setAreaForSearch(parseRes.details?.unMappedAreas || []);

        return;
      }
    }

    // Fallback: try /settings/areas
    try {
      const fallbackRes = await axios.get(BASE_URL + "/settings/areas", {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });

      const resData = fallbackRes.data;

      let list = [];

      if (Array.isArray(resData)) {
        list = Array.isArray(resData[1]) ? resData[1] : resData;
      } else if (resData?.details?.areaList) {
        list = resData.details.areaList;
      } else if (resData?.details?.unMappedAreas) {
        list = resData.details.unMappedAreas;
      } else if (Array.isArray(resData?.data)) {
        list = resData.data;
      } else if (Array.isArray(resData?.data?.data)) {
        list = resData.data.data;
      } else if (Array.isArray(resData?.areas)) {
        list = resData.areas;
      }

      if (Array.isArray(list) && list.length > 0) {
        setAreaForSearch(list);
      }
    } catch (err) {
      console.log("Error fetching fallback areas in RestaurantContext:", err);
    }
  };
  //zones
  const setZone = (res) => {
    setZoneList(res.data.details?.pagination);
    setZoneForSearch(res.data.details?.zoneList);
    setLoading(false);
  };

  //get zone
  const getZones = async () => {
    setLoading(true);
    const branchUrl = BASE_URL + "/settings/zones";
    try {
      const res = await axios.get(branchUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setZone(res);
      // localStorage.setItem(branchUrl, JSON.stringify(res));
    } catch (error) {
      // if (offline(branchUrl)) {
      //   let parseRes = JSON.parse(localStorage.getItem(branchUrl));
      //   setZone(parseRes);
      // }
      setLoading(false);
    }
  };

  const setPaginatedZone = (res) => {
    if (res.data.code == 1) {
      setZoneList(res.data.details?.pagination);
      setZoneForSearch(res.data.details?.zoneList);
    }
    setDataPaginating(false);
  };

  // get paginated zones
  const setPaginatedZones = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/zones?page=" + pageNo;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setPaginatedZone(res);
        // localStorage.setItem(url, JSON.stringify(res));
      })
      .catch((error) => {
        setDataPaginating(false);
        // if (offline(url)) {
        //   let parseRes = JSON.parse(localStorage.getItem(url));
        //   setPaginatedOrderTypes(parseRes);
        // }
      });
  };

  const setPaginatedLocations = (res) => {
    setLocationList(res.data[0]);
    setLocationForSearch(res.data[1]);
    setLoading(false);
    setDataPaginating(false);
  };

  // get paginated location
  const setPaginatedLocation = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/location?page=" + pageNo;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setPaginatedLocations(res);
      })
      .catch((error) => {
        setDataPaginating(false);
      });
  };

  //get location
  const getLocation = async () => {
    setLoading(true);
    const branchUrl = BASE_URL + "/settings/location";
    try {
      const res = await axios.get(branchUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedLocations(res);
    } catch (error) {
      setLoading(false);
    }
  };

  const setPaginatedReasons = (res) => {
    setReasonList(res.data[0]);
    setReasonForSearch(res.data[1]);
    setLoading(false);
    setDataPaginating(false);
  };

  // get paginated reason
  const setPaginatedReason = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/reason?page=" + pageNo;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setPaginatedReasons(res);
      })
      .catch((error) => {
        setDataPaginating(false);
      });
  };

  //get reason
  const getReason = async () => {
    setLoading(true);
    const branchUrl = BASE_URL + "/settings/reason";
    try {
      const res = await axios.get(branchUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedReasons(res);
    } catch (error) {
      setLoading(false);
    }
  };

  const setOrderType = (res) => {
    setOrderTypeList(res.data[0]);
    setOrderTypeForSearch(res.data[1]);
    setLoading(false);
  };

  //get orderType
  const getOrderType = async () => {
    setLoading(true);
    const branchUrl = BASE_URL + "/settings/get-order-types";
    try {
      const res = await axios.get(branchUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setOrderType(res);
      setDataToLocal(branchUrl, res);
    } catch (error) {
      setLoading(false);
      if (offline(branchUrl)) {
        let parseRes = JSON.parse(localStorage.getItem(branchUrl));
        setOrderType(parseRes);
      }
    }
  };

  const setPaginatedOrderTypes = (res) => {
    setOrderTypeList(res.data[0]);
    setOrderTypeForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated order type
  const setPaginatedOrderType = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-order-types?page=" + pageNo;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setPaginatedOrderTypes(res);
        // localStorage.setItem(url, JSON.stringify(res));
      })
      .catch((error) => {
        setDataPaginating(false);
        // if (offline(url)) {
        //   let parseRes = JSON.parse(localStorage.getItem(url));
        //   setPaginatedOrderTypes(parseRes);
        // }
      });
  };

  const setFloors = (res) => {
    setFloorList(res.data[0]);
    setFloorforSearch(res.data[1]);
    setLoading(false);
  };

  //get tables
  const getFloor = () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-floor";
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFloors(res);
        setDataToLocal(url, res);
      })
      .catch((error) => {
        setLoading(false);
        if (offline(url)) {
          let parseRes = JSON.parse(localStorage.getItem(url));
          setFloors(parseRes);
        }
      });
  };

  const setTables = (res) => {
    setTableList(res.data[0]);
    setTableforSearch(res.data[1]);
    setLoading(false);
  };

  //get tables
  const getTable = async () => {
    setTableLoading(true);
    const endPoint = "/settings/get-table";
    const url = getApiUrl(endPoint, authUserInfo, generalSettings);

    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setTables(res);
        setTableLoading(false);
        setDataToLocal(url, res);
      })
      .catch((error) => {
        setTableLoading(false);
        if (offline(url)) {
          let parseRes = JSON.parse(localStorage.getItem(url));
          setTables(parseRes);
        }
      });
  };

  const setPaginatedFloors = (res) => {
    setFloorList(res.data[0]);
    setFloorforSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated tables
  const setPaginatedFloor = (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-floor?page=" + pageNo;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setPaginatedFloors(res);
        // localStorage.setItem(url, JSON.stringify(res));
      })
      .catch((error) => {
        setDataPaginating(false);
        // if (offline(url)) {
        //   let parseRes = JSON.parse(localStorage.getItem(url));
        //   setPaginatedFloors(parseRes);
        // }
      });
  };

  const setPaginatedTables = (res) => {
    setTableList(res.data[0]);
    setTableforSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated tables
  const setPaginatedTable = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-table?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedTables(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedTables(parseRes);
      // }
    }
  };

  const setPaymentTypes = (res) => {
    setPaymentTypeList(res.data[0]);
    setPaymentTypeforSearch(res.data[1]);
    setLoading(false);
  };

  //get payment types
  const getPaymentType = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-payment-type";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaymentTypes(res);
      setDataToLocal(url, res);
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setPaymentTypes(parseRes);
      }
    }
  };

  const setBankNames = (res) => {
    setBankNameForSearch(res.data);
    setLoading(false);
  };

  //get bank names
  const getBankNameList = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/bank-name";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setBankNames(res);
      setDataToLocal(url, res);
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setBankNames(parseRes);
      }
    }
  };

  const setPaymentTypeTaxes = (res) => {
    setPaymentTypeTaxforSearch(res.data);
    setLoading(false);
  };

  //get payment types
  const getPaymentTypeTax = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-payment-tax";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaymentTypeTaxes(res);
      setDataToLocal(url, res);
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setPaymentTypeTaxes(parseRes);
      }
    }
  };

  const setPaginatedPaymentTypes = (res) => {
    setPaymentTypeList(res.data[0]);
    setPaymentTypeforSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated payment types
  const setPaginatedPaymentType = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-payment-type?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedPaymentTypes(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedPaymentTypes(parseRes);
      // }
    }
  };

  const setDeptTags = (res) => {
    setDeptTagList(res.data[0]);
    setDeptTagForSearch(res.data[1]);
    setLoading(false);
  };

  //get dept Tag
  const getDeptTag = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-dept-tag";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setDeptTags(res);
      setDataToLocal(url, res);
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setDeptTags(parseRes);
      }
    }
  };

  const setPaginatedDeptTags = (res) => {
    setDeptTagList(res.data[0]);
    setDeptTagForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated dept Tag
  const setPaginatedDeptTag = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-dept-tag?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedDeptTags(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedDeptTags(parseRes);
      // }
    }
  };

  const setKOTs = (res) => {
    setKOTList(res.data[0]);
    setKOTForSearch(res.data[1]);
    setLoading(false);
  };

  //get dept Tag
  const getKOT = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-kot";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setKOTs(res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setKOTs(parseRes);
      // }
      setLoading(false);
    }
  };

  const setPaginatedKOTs = (res) => {
    setKOTList(res.data[0]);
    setKOTForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated dept Tag
  const setPaginatedKOT = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-kot?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedKOTs(res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedKOTs(parseRes);
      // }
    }
  };

  const setSchemes = (res) => {
    setSchemeList(res.data[0]);
    setSchemeForSearch(res.data[1]);
    const obj = {};
    res.data[1]?.length &&
      res.data[1].map((scheme) => {
        obj[parseInt(scheme.id)] = scheme;
      });
    setSchemeForSearchObj(obj);
    setLoading(false);
  };

  //get dept Tag
  const getScheme = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-schemes";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setSchemes(res);
      setDataToLocal(url, res);
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setSchemes(parseRes);
      }
    }
  };

  const setPaginatedSchemes = (res) => {
    setSchemeList(res.data[0]);
    setSchemeForSearch(res.data[1]);
    const obj = {};
    res.data[1]?.length &&
      res.data[1].map((scheme) => {
        obj[parseInt(scheme.id)] = scheme;
      });
    setSchemeForSearchObj(obj);
    setDataPaginating(false);
  };

  // get paginated schemes
  const setPaginatedScheme = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-schemes?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedSchemes(res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedSchemes(parseRes);
      // }
    }
  };

  // cards stuff
  const setCard = (res) => {
    setCardList(res.data[0]);
    setCardForSearch(res.data[1]);
    setLoading(false);
  };

  const getCard = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-card-info";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setCard(res);
    } catch (error) {
      setLoading(false);
    }
  };

  const setPaginatedCards = (res) => {
    setCardList(res.data[0]);
    setCardForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated cards
  const setPaginatedCard = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-card-info?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedCards(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedCards(parseRes);
      // }
    }
  };

  const setMasterVoucher = (res) => {
    setVoucherMaster(res.data);
    setLoading(false);
  };

  const getMasterVoucher = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-voucher";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setMasterVoucher(res);
    } catch (error) {
      setLoading(false);
    }
  };

  // cards stuff
  const setVoucher = (res) => {
    setVoucherList(res.data[0]);
    setVoucherForSearch(res.data[1]);
    setDataPaginating(false);
    setLoading(false);
  };

  // get paginated voucher
  const setPaginatedVoucher = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/voucher?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setVoucher(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setWorkPeriodForBranch = (res) => {
    setWorkPeriodListForBranch(res.data);
    setLoading(false);
  };

  //get work period
  const getWorkPeriodForBranch = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-work-period-by-branch";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setWorkPeriodForBranch(res);
      setDataToLocal(url, res);
      return res;
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setWorkPeriodForBranch(parseRes);
        return parseRes;
      }
    }
  };

  const setWorkPeriod = (res) => {
    setWorkPeriodList(res.data[0]);
    setWorkPeriodListForSearch(res.data[1]);
    setLoading(false);
  };

  //get work period
  const getWorkPeriod = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-work-period";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setWorkPeriod(res);
      setDataToLocal(url, res);
      return res;
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setWorkPeriod(parseRes);
        return parseRes;
      }
    }
  };

  const setPaginatedWorkPeriods = (res) => {
    setWorkPeriodList(res.data[0]);
    setWorkPeriodListForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated work period
  const setPaginatedWorkPeriod = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-work-period?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedWorkPeriods(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedWorkPeriods(parseRes);
      // }
    }
  };

  const setRunningOrder = (res) => {
    setRunningOrders({
      list: res.data,
      searchList: null,
    });
    setLoading(false);
  };

  //get submitted orders- not settled
  const getRunningOrders = async () => {
    setLoading(true);
    const endPoint = "/settings/get-running-orders";
    const url = getApiUrl(endPoint, authUserInfo, generalSettings);
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setRunningOrder(res);
    } catch (error) {}
  };

  const setSubmittedOrder = (res) => {
    setSubmittedOrders(res.data[0]);
    setSubmittedOrdersForSearch(res.data[1]);
    setLoading(false);
  };

  //get submitted orders- not settled
  const getSubmittedOrders = async () => {
    setLoading(true);
    const endPoint = "/settings/get-submitted-orders";
    const url = getApiUrl(endPoint, authUserInfo, generalSettings);
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setSubmittedOrder(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setSubmittedOrder(parseRes);
      // }
      setLoading(false);
    }
  };

  const setPaginatedSubmittedOrder = (res) => {
    setSubmittedOrders(res.data[0]);
    setSubmittedOrdersForSearch(res.data[1]);
    setTimeout(() => {
      setDataPaginating(false);
    }, 500);
  };

  // get paginated submitted orders- not settled
  const setPaginatedSubmittedOrders = async (pageNo = 1) => {    
    setDataPaginating(true);
    
    const controller = getAbortController('paginatedSubmittedOrders');
    const endPoint = "/settings/get-submitted-orders?page=" + pageNo;
    const url = getApiUrl(endPoint, authUserInfo, generalSettings);

    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
        signal: controller.signal,
      });
      //localStorage.setItem(url, JSON.stringify(res));
      setPaginatedSubmittedOrder(res);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request canceled due to race condition:', error.message);
        return; // Do not update state if request was cancelled
      }
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedSubmittedOrder(parseRes);
      // }
    }
  };

  const setSettledOrder = (res) => {
    setSettledOrders(res.data[0]);
    setSettledOrdersForSearch(res.data[1]);
    setLoading(false);
  };

  //get settled orders
  const getSettledOrders = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-settled-orders";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      // localStorage.setItem(url, JSON.stringify(res));
      setSettledOrder(res);
      console.log("resresresres", res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setSettledOrder(parseRes);
      // }
      setLoading(false);
    }
  };

  const setPaginatedSettledOrder = (res) => {
    setSettledOrders(res.data[0]);
    setSettledOrdersForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated settled orders
  const setPaginatedSettledOrders = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-settled-orders?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedSettledOrder(res);
      setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      if (offline(url)) {
        let parseRes = getDataFromLocal(url);
        setPaginatedSettledOrder(parseRes);
      }
    }
  };

  const setKitchenNewOrder = (res) => {
    setKithcenNewOrders(res.data[0]);
    setLoading(false);
    return res.data[0];
  };
  //get kithcen new orders
  const getKitchenNewOrders = async (type = "Kitchen") => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-new-orders/" + type;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setKitchenNewOrder(res);
      setDataToLocal(url, res);
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setKitchenNewOrder(parseRes);
      }
    }
  };

  const setKitchenNewOrderOnline = (res) => {
    setKithcenNewOrdersOnline(res.data[0]);
    setLoading(false);
  };

  // kitchen online orders
  const getKitchenNewOrdersOnline = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-new-orders-online";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setKitchenNewOrderOnline(res);
      setDataToLocal(url, res);
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setKitchenNewOrderOnline(parseRes);
      }
    }
  };

  const setAllOrder = (res) => {
    setAllOrdersForSearch(res.data);
    setLoading(false);
  };

  //get all orders for order history
  const getAllOrders = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-order-history-all";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      //localStorage.setItem(url, JSON.stringify(res));
      setAllOrder(res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setAllOrder(parseRes);
      // }
      setLoading(false);
    }
  };

  const setAllPaginatedOrders = (res) => {
    setAllOrders(res.data);
    setDataPaginating(false);
    setLoading(false);
  };

  // get paginated settled orders
  const setPaginatedAllOrders = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-order-history?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      //localStorage.setItem(url, JSON.stringify(res));
      setAllPaginatedOrders(res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setAllPaginatedOrders(parseRes);
      // }
    }
  };

  const setAllOnlineOrder = (res) => {
    setAllOnlineOrdersForSearch(res.data);
    setLoading(false);
  };

  // const setPaginatedFilteredOrders = async (params) => {
  //   setDataPaginating(true);
  //   const url = BASE_URL + `/settings/get-order-history-filter`;
  //   try {
  //     const res = await axios.post(url, params, {
  //       headers: { Authorization: `Bearer ${getCookie()}` },
  //     });
  //     // localStorage.setItem(url, JSON.stringify(res));
  //     if (params.type === "pos") setAllOrdersForSearch(res.data);
  //     if (params.type === "online") setAllOnlineOrdersForSearch(res.data);
  //     setDataPaginating(false);
  //     setLoading(false);
  //   } catch (error) {
  //     if (offline(url)) {
  //       let parseRes = JSON.parse(localStorage.getItem(url));
  //       if (params.type === "pos") setAllOrdersForSearch(parseRes.data);
  //       if (params.type === "online")
  //         setAllOnlineOrdersForSearch(parseRes.data);
  //       setDataPaginating(false);
  //       setLoading(false);
  //     }
  //   }
  // };

  const setPaginatedFilteredOrders = async (params) => {
    setDataPaginating(true);
    const url = BASE_URL + `/settings/get-order-histories`;
    try {
      const res = await axios.post(url, params, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      // localStorage.setItem(url, JSON.stringify(res));
      if (params.type === "pos") setAllOrdersForSearch(res.data);
      if (params.type === "online") setAllOnlineOrdersForSearch(res.data);
      setDataPaginating(false);
      setLoading(false);
    } catch (error) {
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        if (params.type === "pos") setAllOrdersForSearch(parseRes.data);
        if (params.type === "online")
          setAllOnlineOrdersForSearch(parseRes.data);
      }
      setDataPaginating(false);
      setLoading(false);
    }
  };

  const setPaginatedSearchOrders = async (params) => {
    setDataPaginating(true);
    const url = BASE_URL + `/settings/get-order-histories?page=` + params.page;
    try {
      const res = await axios.post(url, params, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      // localStorage.setItem(url, JSON.stringify(res));
      if (params.type === "pos") setAllOrdersForSearch(res.data);
      if (params.type === "online") setAllOnlineOrdersForSearch(res.data);
      setDataPaginating(false);
      setLoading(false);
    } catch (error) {
      setDataPaginating(false);
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        if (params.type === "pos") setAllOrdersForSearch(parseRes.data);
        if (params.type === "online")
          setAllOnlineOrdersForSearch(parseRes.data);
      }
    }
  };

  const setPaginatedSearchedOrders = async (params) => {
    setDataPaginating(true);
    const url = BASE_URL + `/settings/get-order-history-search`;
    try {
      const res = await axios.post(url, params, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      // localStorage.setItem(url, JSON.stringify(res));
      if (params.type === "pos") setAllOrdersForSearch(res.data);
      if (params.type === "online") setAllOnlineOrdersForSearch(res.data);
      setDataPaginating(false);
      setLoading(false);
    } catch (error) {
      setDataPaginating(false);
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        if (params.type === "pos") setAllOrdersForSearch(parseRes.data);
        if (params.type === "online")
          setAllOnlineOrdersForSearch(parseRes.data);
      }
    }
  };

  //get all  online orders for order history
  const getAllOnlineOrders = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-online-order-history-all";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      //localStorage.setItem(url, JSON.stringify(res));
      setAllOnlineOrder(res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setAllOnlineOrder(parseRes);
      // }
      setLoading(false);
    }
  };

  const setAllPaginatedOnlineOrder = (res) => {
    setAllOnlineOrders(res.data);
    setDataPaginating(false);
    setLoading(false);
  };

  // get paginated online  orders
  const setPaginatedAllOnlineOrders = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-online-order-history?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      //localStorage.setItem(url, JSON.stringify(res));
      setAllPaginatedOnlineOrder(res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setAllPaginatedOnlineOrder(parseRes);
      // }
      setDataPaginating(false);
    }
  };

  const setPurchaseOrder = (res) => {
    setPurchaseOrderList(res.data[0]);
    setPurchaseOrderListForSearch(res.data[1]);
    setLoading(false);
  };

  //get food purchases
  const getPurchaseOrder = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/purchase-order";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPurchaseOrder(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const setPaginatedPurchasesOrder = (res) => {
    setPurchaseOrderList(res.data[0]);
    setPurchaseOrderListForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated purchases
  const getPaginatedPurchaseOrder = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/purchase-order?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedPurchasesOrder(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setPaginatedClosingStock = (res) => {
    setClosingStockList(res.data[0]);
    setClosingStockListForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated closing stock
  const getPaginatedClosingStock = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/closing-stock?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedClosingStock(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setPurchaseRequest = (res) => {
    setPurchaseRequestList(res.data[0]);
    setPurchaseRequestListForSearch(res.data[1]);
    setLoading(false);
  };

  //get food purchases
  const getPurchaseRequest = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/purchase-request";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPurchaseRequest(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };


  const setPaginatedPurchasesRequest = (res) => {
    setPurchaseRequestList(res.data[0]);
    setPurchaseRequestListForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated purchases
  const getPaginatedPurchaseRequest = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/purchase-request?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedPurchasesRequest(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setSaleOrder = (res) => {
    setFgSaleInvoiceList(res.data[0]);
    setFgSaleInvoiceForSearch(res.data[1]);
    setLoading(false);
  };

  //get food purchases
  const getSaleOrder = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-purchase-order";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setSaleOrder(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const setPaginatedSaleOrders = (res) => {
    setFgSaleOrderList(res.data[0]);
    setFgSaleOrderForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated sale orders
  const getPaginatedFgSaleOrder = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/finished-good-sale-order?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedSaleOrders(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setFgPaginatedSaleInvoices = (res) => {
    setFgSaleInvoiceList(res.data[0]);
    setFgSaleInvoiceForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated invoices
  const getPaginatedFgSaleInvoice = async (pageNo) => {
    setDataPaginating(true);
    const url =
      BASE_URL + "/settings/finished-good-sale-invoice?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setFgPaginatedSaleInvoices(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setPaginatedFgSaleReturn = (res) => {
    setFgSaleReturnList(res.data[0]);
    setFgSaleReturnForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated purchases
  const getPaginatedFgSaleReturn = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/finished-good-return?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFgSaleReturn(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };
  const setPaginatedSaleReturn = (res) => {
    setSaleReturnList(res.data[0]);
    setSaleReturnForSearch(res.data[1]);
    setDataPaginating(false);
  };

  const getPaginatedReturnOrder = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/sale-return?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedSaleReturn(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setIngredientPurchase = (res) => {
    setIngredientPurchaseHistory(res.data[0]);
    setIngredientPurchaseHistoryForSearch(res.data[1]);
    setLoading(false);
  };

  //get food purchases
  const getIngredientPurchase = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-ingredient_purchase";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setIngredientPurchase(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setLoading(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setIngredientPurchase(parseRes);
      // }
    }
  };

  const setPaginatedIngredientPurchases = (res) => {
    setIngredientPurchaseHistory(res.data[0]);
    setIngredientPurchaseHistoryForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated purchases
  const setPaginatedIngredientPurchase = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-ingredient_purchase?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedIngredientPurchases(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedIngredientPurchases(parseRes);
      // }
    }
  };

  const setPaginatedSaleInvoices = (res) => {
    setSaleInvoice(res.data[0]);
    setSaleInvoiceForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated purchases
  const setPaginatedSaleInvoice = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/sale-invoice?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedSaleInvoices(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setPurchaseReturn = (res) => {
    setPurchaseReturnHistory(res.data[0]);
    setPurchaseHistoryReturnForSearch(res.data[1]);
    setDataPaginating(false);
    setLoading(false);
  };

  //get purchases return
  const getPurchaseReturn = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/purchase-return";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPurchaseReturn(res);
    } catch (error) {
      setLoading(false);
    }
  };

  // get paginated purchases return
  const setPaginatedPurchaseReturn = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/purchase-return?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPurchaseReturn(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  //get expense
  const setExpenses = (res) => {
    setExpense(res.data[0]);
    setExpenseForSearch(res.data[1]);
    setLoading(false);
  };

  const getExpense = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-expense";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setExpenses(res);
      setDataToLocal(url, res);
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setExpenses(parseRes);
      }
    }
  };

  const setPaginatedExpense = (res) => {
    setExpense(res.data[0]);
    setExpenseForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated expense
  const getPaginatedExpense = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-expense?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedExpense(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedExpense(parseRes);
      // }
    }
  };

  //get payment expense List
  const setExpensesList = (res) => {
    setPaymentExpense(res.data[0]);
    setPaymentExpenseForSearch(res.data[1]);
    setLoading(false);
  };

  const getExpenseList = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-payment-expense";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setExpensesList(res);
      localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setLoading(false);
      if (offline(url)) {
        let parseRes = JSON.parse(localStorage.getItem(url));
        setExpensesList(parseRes);
      }
    }
  };

  const setPaginatedExpenseList = (res) => {
    setPaymentExpense(res.data[0]);
    setPaymentExpenseForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated expense
  const getPaginatedExpenseList = async (pageNo = 1, from_date, to_date) => {
    setDataPaginating(true);
    let url = BASE_URL + "/settings/get-payment-expense?page=" + pageNo;
    if (from_date) {
      url += `&from_date=${from_date}`;
    }
    if (to_date) {
      url += `&to_date=${to_date}`;
    }
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedExpenseList(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setPaginatedExpenseList(parseRes);
      // }
    }
  };

  //Good receive notes ctx
  const setGoodRecieveNotes = (res) => {
    setGoodReceiveList(res.data[0]);
    setGoodReceiveListForSearch(res.data[1]);
    setLoading(false);
  };

  //get notes
  const getGoodRecieveNotes = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/goods-received-note";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setGoodRecieveNotes(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setIngredientPurchase(parseRes);
      // }
      setLoading(false);
    }
  };

  const setPaginatedGoodRecieveNotes = (res) => {
    setGoodReceiveList(res.data[0]);
    setGoodReceiveListForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated purchases
  const setPaginatedGoodsRecieveNotes = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/goods-received-note?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedGoodRecieveNotes(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  //set kds setting
  const setKdsListSetting = (res) => {
    setKdsList(res.data);
    setKdsListForSearch(res.data);
    setLoading(false);
  };

  //get kds setting
  const getKdsList = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/kdssettings";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setKdsListSetting(res);
      // localStorage.setItem(url, JSON.stringify(res));
    } catch (error) {
      setLoading(false);
      // if (offline(url)) {
      //   let parseRes = JSON.parse(localStorage.getItem(url));
      //   setIngredientPurchase(parseRes);
      // }
    }
  };

  return (
    <RestaurantContext.Provider
      value={{
        //common
        loading,
        setLoading,
        tableLoading,
        //delvery pending
        getDeliveryPendingOrders,
        pendingOrdersDelivery,
        setPendingOrdersDelivery,
        pendingOrdersDeliveryForSearch,
        setPendingOrdersDeliveryForSearch,
        setPaginatedDeliveryPendingOrders,

        //delivery delivered
        getDeliveryDeliveredOrders,
        deliveredOrdersDelivery,
        setDeliveredOrdersDelivery,
        deliveredOrdersDeliveryForSearch,
        setDeliveredOrdersDeliveryForSearch,
        setPaginatedDeliveryDeliveredOrders,

        //ingredient group
        getIngredientGroup,
        ingredientGroupList,
        setIngredientGroupList,
        setPaginatedIngredientGroup,
        ingredientGroupForSearch,
        setIngredientGroupForSearch,

        //Recipes
        recipeList,
        recipeForSearch,
        setRecipeList,
        setRecipeForSearch,
        setPaginatedRecipeList,
        getRecipes,

        //md integration
        MdIntegrationList,
        setMdIntegrationList,
        MdIntegrationForSearch,
        setMdIntegrationForSearch,
        setPaginatedMdIntegrationGroup,
        getMdIntegrationGroup,

        //production
        getProductionItem,
        setPaginatedProductionItem,
        setProductionItemList,
        setProductionItemForSearch,
        productionItemList,
        productionItemForSearch,

        //ingredient item
        getIngredientItem,
        ingredientItemList,
        setIngredientItemList,
        setPaginatedIngredientItem,
        ingredientItemForSearch,
        setIngredientItemForSearch,
        ingredientItemNonPurchase, 
        setIngredientItemNonPurchase,
        ingredientItemListForSearch,
        setIngredientItemListForSearch,
        ingredientItemStock,
        setIngredientItemStock,
        getIngredientUnit,

        //ingredient limit
        setPaginatedIngredientLimit,
        setIngredientLimitList,
        setIngredientLimitForSearch,
        getIngredientLimit,
        ingredientLimitList,
        ingredientLimitForSearch,
        ingredientLimitCheck,

        //ingredient purchases
        getIngredientPurchase,
        ingredientPurchaseHistory,
        setIngredientPurchaseHistory,
        setPaginatedIngredientPurchase,
        ingredientPurchaseHistoryForSearch,
        setIngredientPurchaseHistoryForSearch,
        ingredientUnitForSearch,
        setIngredientUnitForSearch,
        ingredientList,
        setIngredientList,
        // getRecipes,

        //sale invoice
        saleInvoice,
        setSaleInvoice,
        saleInvoiceForSearch,
        setSaleInvoiceForSearch,
        setPaginatedSaleInvoice,

        //ingredient purchase return
        purchaseReturnHistory,
        setPurchaseReturnHistory,
        purchaseHistoryReturnForSearch,
        setPurchaseHistoryReturnForSearch,
        getPurchaseReturn,
        setPaginatedPurchaseReturn,

        //purchase order
        getPurchaseOrder,
        getPaginatedPurchaseOrder,
        setPurchaseOrderList,
        setPurchaseOrderListForSearch,
        purchaseOrderList,
        purchaseOrderListForSearch,

        //closing stock
        getPaginatedClosingStock,
        setClosingStockList,
        setClosingStockListForSearch,
        closingStockList,
        closingStockListForSearch,

        //fg sale order
        fgSaleOrderList,
        setFgSaleOrderList,
        fgSaleOrderForSearch,
        setFgSaleOrderForSearch,
        getPaginatedFgSaleOrder,
        getSaleOrder,

        //fg sale invoice
        getPaginatedFgSaleInvoice,
        setFgSaleInvoiceList,
        setFgSaleInvoiceForSearch,
        fgSaleInvoiceList,
        fgSaleInvoiceForSearch,

        //fg sale return
        fgSaleReturnList,
        setFgSaleReturnList,
        fgSaleReturnForSearch,
        setFgSaleReturnForSearch,
        getPaginatedFgSaleReturn,

        //sale return
        getPaginatedReturnOrder,
        saleReturnList,
        setSaleReturnList,
        saleReturnForSearch,
        setSaleReturnForSearch,
        //PR
        purchaseRequestList,
        setPurchaseRequestList,
        purchaseRequestListForSearch,
        setPurchaseRequestListForSearch,
        getPurchaseRequest,
        getPaginatedPurchaseRequest,

        //website
        getBranchWeb,
        branchListWeb,
        setBranchListWeb,
        //branch
        getBranch,
        branchList,
        setBranchList,
        setPaginatedBranch,
        branchForSearch,
        setBranchforSearch,
        setBranchListforSearch,
        getPaginatedBranchList,
        branchForListSearch,

        //location
        getLocation,
        setPaginatedLocation,
        locationList,
        locationForSearch,
        setLocationList,
        setLocationForSearch,

        //reason
        setPaginatedReason,
        getReason,
        reasonList,
        setReasonList,
        reasonForSearch,
        setReasonForSearch,

        //zone
        getZones,
        zoneList,
        zoneForSearch,
        setZoneList,
        setZoneForSearch,
        setPaginatedZones,

        //get areas
        getAreas,
        areaList,
        setAreaList,
        areaForSearch,
        setAreaForSearch,

        //branch list
        GetBranchList,
        getBranchList,
        setGetBranchList,
        getBranchForSearch,
        setGetBranchforSearch,

        //order types
        getOrderType,
        orderTypeList,
        setOrderTypeList,
        setPaginatedOrderType,
        orderTypeForSearch,
        setOrderTypeForSearch,

        //table
        getTable,
        tableList,
        setTableList,
        setPaginatedTable,
        tableForSearch,
        setTableforSearch,

        //table
        getFloor,
        floorList,
        setFloorList,
        setPaginatedFloor,
        floorForSearch,
        setFloorforSearch,

        //dept-tag
        getDeptTag,
        deptTagList,
        setDeptTagList,
        setPaginatedDeptTag,
        deptTagForSearch,
        setDeptTagForSearch,

        //kot
        getKOT,
        KOTList,
        setKOTList,
        setPaginatedKOT,
        KOTForSearch,
        setKOTForSearch,

        //scheme
        getScheme,
        schemeList,
        setSchemeList,
        setPaginatedScheme,
        schemeForSearch,
        setSchemeForSearch,
        schemeForSearchObj,
        setSchemeForSearchObj,

        //card
        getCard,
        cardList,
        setCardList,
        cardForSearch,
        setCardForSearch,
        setPaginatedCard,

        //voucher
        setPaginatedVoucher,
        voucherList,
        setVoucherList,
        voucherForSearch,
        setVoucherForSearch,
        getMasterVoucher,
        voucherMaster,

        //payment types
        getPaymentType,
        paymentTypeList,
        setPaymentTypeList,
        setPaginatedPaymentType,
        paymentTypeForSearch,
        setPaymentTypeforSearch,

        //bank names
        bankNameForSearch,
        setBankNameForSearch,
        getBankNameList,

        //payment type Taxes
        getPaymentTypeTax,
        paymentTypeTaxForSearch,
        setPaymentTypeTaxforSearch,

        //work period
        getWorkPeriod,
        workPeriodList,
        setWorkPeriodList,
        setPaginatedWorkPeriod,
        workPeriodForSearch,
        setWorkPeriodListForSearch,
        // setDayOpen,
        // dayOpen,
        // setOpenDay,
        getWorkPeriodForBranch,
        workPeriodListForBranch,
        setWorkPeriodListForBranch,
        //running order
        getRunningOrders,
        runningOrders,
        setRunningOrders,

        //submitted orders
        getSubmittedOrders,
        submittedOrders,
        setSubmittedOrders,
        setPaginatedSubmittedOrders,
        submittedOrdersForSearch,
        setSubmittedOrdersForSearch,

        //settled orders
        getSettledOrders,
        settledOrders,
        setSettledOrders,
        setPaginatedSettledOrders,
        settledOrdersForSearch,
        setSettledOrdersForSearch,

        //kitchen dashboard
        getKitchenNewOrders,
        kithcenNewOrders,
        setKithcenNewOrders,
        getKitchenNewOrdersOnline,
        kithcenNewOrdersOnline,
        setKithcenNewOrdersOnline,

        //order histories
        getAllOrders,
        allOrders,
        setAllOrders,
        setPaginatedAllOrders,
        setPaginatedFilteredOrders,
        setPaginatedSearchOrders,
        setPaginatedSearchedOrders,
        allOrdersForSearch,
        setAllOrdersForSearch,

        //order status
        getStatus,
        orderStatus,

        //expense
        setExpense,
        setExpenseForSearch,
        expense,
        expenseForSearch,
        getExpense,
        getPaginatedExpense,

        // payment expense
        expensePayment,
        setPaymentExpense,
        paymentExpenseForSearch,
        setPaymentExpenseForSearch,
        getPaginatedExpenseList,
        getExpenseList,
        //brands
        setBrandPagination,
        brandList,
        setBrandList,
        brandForSearch,
        setBrandForSearch,
        brandStatus,
        setbrandStatus,

        //onlineOrder histories
        getAllOnlineOrders,
        allOnlineOrders,
        setAllOnlineOrders,
        setPaginatedAllOnlineOrders,
        allOnlineOrdersForSearch,
        setAllOnlineOrdersForSearch,

        //goods recieve
        goodReceiveList,
        setGoodReceiveList,
        goodReceiveListForSearch,
        setGoodReceiveListForSearch,
        getGoodRecieveNotes,
        setPaginatedGoodsRecieveNotes,

        //KDS Setting
        kdsList,
        setKdsList,
        kdsListForSearch,
        setKdsListForSearch,
        getKdsList,
        orderCounter,
        setOrderCounter,
        audioInstance,
        bellRing,
        setBellRing,
        //pagination
        dataPaginating,
        setDataPaginating,
        setPaginatedIngredientUnit,

      }}
    >
      {children}
    </RestaurantContext.Provider>
  );
};

export { RestaurantContext, RestaurantProvider };
